import { RouteName } from "constant/routeNames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setVideoStart } from "redux/VideoPlayerRedux";
import LazyLoading from "./LazyLoading";
import { FaPlay, FaCrown } from "react-icons/fa";
import { Modal } from "antd";
import "styles/card.css";
import SubscriptionService from "services/subscription/subscriptionService";

function EpisodeCard({ video, id, season, slug, plan_id }: any) {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const { lastWatched } = useSelector((state: any) => state?.video);
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [mouseHover, setMouseHover] = useState<boolean>(false);
  const [watchTimePercenatage, setWatchTimePercenatage] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBuy, setIsBuy] = useState<boolean>();

  const isPremiumContent = plan_id === 2;
  const isPlusUser = loggedInUser?.is_subscribed;

  // check content subscribe or not
  const checkIsSubscribe = async () => {
    try {
      const res = await SubscriptionService.checkContentAccessBySlug(slug);
      if (res?.status) {
        setIsBuy(res?.data?.has_access);
      }
    } catch {}
  };

  useEffect(() => {
    checkIsSubscribe();
  }, [slug]);

  const episodeOnClick = () => {
    if (!isBuy) {
      setIsModalOpen(true);
      return;
    }

    navigate(
      RouteName.WatchTVSeries.replace(":slug", slug).replace(
        ":stream",
        video?.stream_key,
      ),
    );
    dispatch(setVideoStart());
    window.location.reload();
  };
  useEffect(() => {
    const findLastWatch = lastWatched.find((v: any) => v.id === video.id);

    if (findLastWatch) {
      setWatchTimePercenatage(
        (findLastWatch.currentTime / findLastWatch.duration) * 100,
      );
    }
  }, [video, lastWatched]);

  return (
    <>
      <Modal
        title={null}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
        className="premium-modal"
        styles={{
          content: { backgroundColor: "#111", border: "1px solid #333" },
        }}
      >
        <div className="flex flex-col items-center justify-center p-6 text-center">
          <div className="bg-[var(--red)]/10 p-4 rounded-full mb-4">
            <FaCrown className="text-4xl text-[var(--red)]" />
          </div>
          <h3 className="mb-2 text-2xl font-bold text-white">
            Premium Content
          </h3>
          <p className="mb-6 text-gray-400">
            This episode is exclusively available for premium subscribers.
            Upgrade your plan to gain full access.
          </p>
          <div className="flex w-full gap-4">
            <button
              onClick={() => setIsModalOpen(false)}
              className="flex-1 py-2 px-4 border border-gray-600 rounded-lg text-gray-300 hover:bg-[#222] font-semibold transition"
            >
              Maybe Later
            </button>
            <Link
              to={RouteName.SubscriptionPlanRoute}
              className="flex-1 py-2 px-4 bg-[var(--red)] text-white rounded-lg hover:opacity-90 font-semibold transition shadow-md flex justify-center items-center"
            >
              View Plans
            </Link>
          </div>
        </div>
      </Modal>

      <div className="h-[220px] w-[270px] hover:scale-105  shadow-lg mx-auto max-sm:w-[160px] max-lg:w-[230px] max-xl:w-[250px] relative group">
        {/* Crown Icon for Premium content - hidden for plus subscribers */}
        {isPremiumContent && !isPlusUser && (
          <div className="absolute top-2 right-2 z-10 bg-[var(--red)] text-white p-1.5 rounded-full shadow-lg pointer-events-none transform transition-transform group-hover:scale-110">
            <FaCrown className="text-sm" />
          </div>
        )}

        {/* <div className="absolute    bottom-[-10px] max-sm:left-4 max-lg:left-4 left-[-15px] mx-auto items-center flex justify-center !z-50 w-full  h-80">
          <button className="p-3 bg-black/30 rounded-full border-[1px] hover:bg-red-600">
            <FaPlay className="" />
          </button>
        </div> */}
        <div
          className=""
          onMouseEnter={() => setMouseHover(true)}
          onMouseLeave={() => setMouseHover(false)}
          onClick={episodeOnClick}
        >
          {mouseHover && (
            <div className="absolute bottom-0 !z-50 flex items-center justify-center w-[270px] h-[280px] video-details-play-button">
              <button className="p-3 rounded-full">
                <FaPlay />
              </button>
            </div>
          )}

          {/* image */}
          <div className="relative w-[100%] rounded-lg max-sm:w-[160px] max-sm:mx-auto object-cover">
            <LazyLoading
              imgSrc={video?.thumbnail}
              imgAlt={"Card pic"}
              imgHeight={"160px"}
              imgWidth={"100%"}
              style={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%",
                height: "100%",
                borderRadius: "5px",
              }}
            />

            <div className="absolute h-[30%] inset-x-0 bottom-0 flex items-center justify-between p-2 mt-10 mb-1  !z-50 bg-gradient-to-t from-[#000] to-transparent rounded-lg">
              {video.duration ? (
                <>
                  <p className="mt-12 text-sm align-bottom text-slate-100">
                    <span>
                      {Math.floor(video.duration / 60) > 0 &&
                        `${Math.floor(video.duration / 60)}h`}
                    </span>
                    <span className="ml-1">
                      {Math.floor(video.duration % 60) > 0 &&
                        `${Math.floor(video.duration % 60)}min`}
                    </span>
                  </p>
                  <div></div>
                </>
              ) : (
                <></>
              )}
            </div>

            {/* card inside content */}
          </div>
        </div>

        <div className=" h-[60px] top-1 mb-2 ">
          <div className="my-[4px]  max-sm:ml-0">
            <p className="text-[14px] font-[600] text-white hover:text-zinc-100 max-sm:w-full">
              {video?.title?.length > 50
                ? `${video?.title?.slice(0, 50)}`
                : video?.title}
            </p>
          </div>
          {watchTimePercenatage && (
            <div className="flex justify-center shadow-lg">
              <div className="absolute rounded-lg top-[-35px]  bg-gray-600 w-[95%] h-[6px] mt-2">
                <div
                  className={`bg-red-500 h-full `}
                  style={{ width: watchTimePercenatage }}
                ></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EpisodeCard;
